// Version 1.2 2022-03-21

import {db} from "@/services/db";
import FirebaseVersion from "./firebaseVersion";

export default class FirebaseRead {
    static readSingleDoc (collectionName, documentId) {
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseRead.readSingleDoc8(collectionName, documentId);
        } else {
            //
        }
    }

        static readSingleDoc8(collectionName, documentId){
            return new Promise( resolve => {
                db.collection(collectionName).doc(documentId)
                    .get().then((doc) => {
                    if (doc.exists) {
                        console.log("Document loaded from " + collectionName );
                        let data = doc.data();
                        data.id = doc.id;
                        resolve(data);
                    } else {
                        console.log("No such document!");
                        resolve(null);
                    }
                }).catch((error) => {
                    console.log("Error getting document:",
                               "CollectionName: ", collectionName,
                                "documentId: ",documentId,
                                error);
                    resolve(null);
                });
            })
        }

    static readDocList (collectionName, queryParameter) {
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseRead.readDocList8(collectionName, queryParameter);
        } else {
            //
        }
    }

        static readDocList8(collectionName, queryParameter) {
            return new Promise(resolve => {
                db.collection(collectionName)
                    .where(queryParameter.field, queryParameter.operator, queryParameter.value)
                    .get()
                    .then((querySnapshot) => {
                        let list = [];
                        querySnapshot.forEach((doc) => {
                            let document = doc.data();
                            document.id = doc.id;
                            list.push(document);
                        });
                        resolve(list);
                    }).catch((error) => {
                    console.log("Error getting document:", error);
                    resolve(null);
                });
            })
        }

    static readDocListDouble (collectionName, queryParameter) {
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseRead.readDocListDouble8(collectionName, queryParameter);
        } else {
            //
        }
    }

        static readDocListDouble8(collectionName, queryParameter) {
            return new Promise(resolve => {
                db.collection(collectionName)
                    .where(queryParameter[0].field, queryParameter[0].operator, queryParameter[0].value)
                    .where(queryParameter[1].field, queryParameter[1].operator, queryParameter[1].value)
                    .get()
                    .then((querySnapshot) => {
                        let list = [];
                        querySnapshot.forEach((doc) => {
                            let document = doc.data();
                            //const bytes = sizeof(document);
                            //console.log ("!!!!!!!!!!!!!! bytes", bytes);
                            document.id = doc.id;
                            list.push(document);
                        });
                        resolve(list);
                    }).catch((error) => {
                    console.log("Error getting document:", collectionName, queryParameter, error);
                    resolve(null);
                });
            })
        }

    static readFullCollectionGroup (collectionName) {
        return new Promise(resolve => {
            db.collectionGroup(collectionName)
                .get()
                .then((querySnapshot) => {
                    let list = [];
                    querySnapshot.forEach((doc) => {
                        let document = doc.data();
                        document.id = doc.id;
                        list.push(document);
                    });
                    resolve(list);
                }).catch((error) => {
                console.log("Error getting document:", error);
                resolve(null);
            });
        })
    }

    static readFullList (collectionName) {
        if ( FirebaseVersion.getVersion() === 8 ) {
            return FirebaseRead.readFullList8(collectionName);
        } else {
            //
        }
    }

    static readFullList8(collectionName) {
        return new Promise(resolve => {
            db.collection(collectionName)
                //.where(queryParameter.field, queryParameter.operator, queryParameter.value)
                .get()
                .then((querySnapshot) => {
                    let list = [];
                    querySnapshot.forEach((doc) => {
                        let document = doc.data();
                        document.id = doc.id;
                        list.push(document);
                    });
                    resolve(list);
                }).catch((error) => {
                console.log("Error getting document:", error);
                resolve(null);
            });
        })
    }
}